import { Lock, Person } from "@mui/icons-material";
import { Box, Button, Card, CardContent, CircularProgress, InputAdornment, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../url";
import theme from "./theme";

const GradientBackground = styled("div")({
    display       : "flex",
    alignItems    : "center",
    justifyContent: "center",
    height        : "100vh",
    background    : theme.palette.primary.main,
});

const StyledCard = styled(Card)({
    padding        : "10%",
    borderRadius   : "0",
});

const StyledBox = styled(Box)({
    display        : "flex",
    alignItems     : "center",
    paddingBottom  : "10vh",
});

const GradientButton = styled(Button)({
    background  : theme.palette.primary.main,
    color       : "#fff",
    fontWeight  : "bold",
    borderRadius: "0",
    boxShadow   : "none"
});

const FlatTextField = styled(TextField)({
    ".MuiInputBase-root": {
        borderRadius: "0",
    }
});

const Login = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading]   = useState(false);

    const login = (e: any) => {
        e.preventDefault();
        setLoading(true);
        fetch(`${window.location.protocol}//${BASE_URL}/dashboard/login`, {
            method : 'POST',
            headers: {"Content-Type": "application/json"},
            body   : JSON.stringify({username, password})
        })
        .then(res => res.status != 200? navigate('/login'): res)
        .then((res: any) => res.json())
        .then(res => localStorage.setItem('token', JSON.stringify(res)))
        .then(() => navigate('/dashboard'))
        .finally(() => setLoading(false));
    }

    useEffect(() => {
        const checkAuth = async () => {
            const token: any = JSON.parse(localStorage.getItem("token") || '{}');
            if (token.access_token) {
                const user = await fetch(`${window.location.protocol}//${BASE_URL}/dashboard/user`, {
                    headers: {
                        Authorization: `Bearer ${token.access_token}`
                    }
                }).then(
                    res => res.json()
                )
                if (user.sub) {
                    navigate('/dashboard');
                }
            }
        };
        checkAuth();
    }, []);

    return (
        <GradientBackground>
            <StyledBox>
                <motion.div
                    initial    = {{ opacity: 0, y: -20 }}
                    animate    = {{ opacity: 1, y: 0 }}
                    transition = {{ duration: 1 }}
                >
                    <StyledCard>
                        <CardContent>
                            <Typography variant="h4" align="center">
                                <img src="/algopays.png" width="100px"/>
                            </Typography>
                            <form onSubmit={login}>
                                <FlatTextField fullWidth
                                    label     = "Username"
                                    type      = "username"
                                    margin    = "normal"
                                    variant   = "outlined"
                                    value     = {username}
                                    onChange  = {e => setUsername(e.target.value)}
                                    slotProps = {{input: {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Person color="primary" />
                                            </InputAdornment>
                                        ),
                                    }}}
                                />
                                
                                <FlatTextField fullWidth
                                    label     = "Password"
                                    type      = "password"
                                    margin    = "normal"
                                    variant   = "outlined"
                                    value     = {password}
                                    onChange  = {e => setPassword(e.target.value)}
                                    slotProps = {{input: {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Lock color="primary" />
                                            </InputAdornment>
                                        ),
                                    }}}
                                />
                                
                                <GradientButton fullWidth
                                    type    = "submit"
                                    variant = "contained"
                                    color   = "secondary"
                                    sx      = {{ mt: 2 }}
                                    disabled = {loading}
                                >
                                    {loading? <CircularProgress size="24px" color="inherit"/>: 'Login'}
                                </GradientButton>
                            </form>
                        </CardContent>
                    </StyledCard>
                </motion.div>
            </StyledBox>
        </GradientBackground>
    );
}

export default Login;